import React, { useEffect, useState } from "react";
import { Box, Button, Typography, Badge, Grid, Paper } from "@mui/material";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import { customeStyle } from "utils/style";
import { APIRouteConstants } from "constants/routeConstants";
import instance from "configs/axiosConfig";
import { getCartCountFromLocalStorage } from "utils/cart";
import { getAccessToken } from "utils";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { formatCurrencyNew } from "utils/helper";
import axiosInstance from "configs/axiosConfig";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const FloatingCartBar = ({ cartCount, subTotal, onViewCart, totalCount, }) => {

    const webDetails = useSelector(state => state.webDetails);
    const { websiteInfo } = webDetails;
    const { enqueueSnackbar } = useSnackbar();
    const handleonViewCart = () => {
        if (cartCount === 0) {
            enqueueSnackbar('Please add items to your cart to proceed.', { variant: 'error' });

            return
        }
        onViewCart()
    }

    const [loader, setLoader] = useState(false);
    const [isWebsiteFunctional, setIsWebsiteFunctional] = useState(false);
    const [hasCheckedWebsiteInfo, setHasCheckedWebsiteInfo] = useState(false); // 🔹 new flag


    const getWebsiteInfo = async () => {
        const websiteData = localStorage.getItem('websiteDetails')
            ? JSON.parse(localStorage.getItem('websiteDetails'))
            : null;
        console.log("status", websiteData);
        if (websiteData) {
            setIsWebsiteFunctional(websiteData?.status);
            setHasCheckedWebsiteInfo(true);
            return
        }
        // setLoader(true);
        // try {
        //     const res = await axiosInstance.get(APIRouteConstants.DASHBOARD.WEB_INFO);
        //     const { data } = res;
        //     console.log("webinfo1", data);
        //     console.log("webinfo2", websiteInfo);
        //     setIsWebsiteFunctional(data.status); // or data?.data?.status
        // } catch (err) {
        //     console.error(err);
        //     setIsWebsiteFunctional(false);
        // } finally {
        //     setLoader(false);
        //     setHasCheckedWebsiteInfo(true); // ✅ mark check as complete
        // }
    };
    useEffect(() => {
        getWebsiteInfo();
    }, []);





    return (
        <Grid
            sx={{
                width: "100%",
                position: "fixed",
                bottom: 16,
                left: 0,
                zIndex: 1000,
                px: 2,
            }}
        >
            <Grid
                lg={10.5}
                margin={"auto"}
                sx={{
                    width: "100%",
                    background: "#000",
                    py: 1,
                    px: 2,
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                    borderRadius: "0.5rem",
                }}
                container
                justifyContent="space-between"
                alignItems="center"
            >
                {/* Left: Bag Icon and Subtotal */}
                <Grid item sx={{ display: "flex", alignItems: "center" }}>
                    <Badge
                        badgeContent={cartCount}
                        sx={{
                            mr: 2,
                            "& .MuiBadge-badge": {
                                backgroundColor: "#0288D1",
                                color: "white",
                                fontSize: customeStyle.typography.subhading1,
                                minWidth: "22px",
                                height: "22px",
                                borderRadius: "50%",
                            },
                        }}
                    >
                        <ShoppingBagIcon fontSize="medium" sx={{ color: "#f7f7f7" }} />
                    </Badge>
                    <Typography sx={{ fontSize: customeStyle.typography.subhading }} color="white">
                        {subTotal > 0 && `${formatCurrencyNew(subTotal || 0, websiteInfo?.currency_symbol)}`}
                    </Typography>
                </Grid>

                {/* Right: Offline Warning + View Cart */}
                <Grid item sx={{ display: "flex", gap: 1 }}>
                    {hasCheckedWebsiteInfo && !isWebsiteFunctional && (
                       
                        <Button
                            disabled
                            startIcon={<WarningAmberIcon />}
                            sx={{
                                borderRadius: "0.5rem",
                                fontSize: customeStyle.typography.subhading1,
                                px: 2.5,
                                backgroundColor: "#e3eafc", // Light tint of blue for background
                                color: "#688ad5",           // Primary blue for text & icon
                                fontWeight: 600,
                                textTransform: "none",
                                border: "2px solid #688ad5",
                                animation: "pulse 2s infinite",
                                "@keyframes pulse": {
                                    "0%": { transform: "scale(1)" },
                                    "50%": { transform: "scale(1.05)" },
                                    "100%": { transform: "scale(1)" },
                                },
                            }}
                        >
                            The Store is Offline
                        </Button>

                    )}

                    <Button
                        variant="contained"
                        onClick={handleonViewCart}
                        //   disabled={!isWebsiteFunctional}
                        sx={{
                            borderRadius: "0.5rem",
                            fontSize: customeStyle.typography.subhading1,
                            px: 3,
                            backgroundColor: "white",
                            color: "black",
                            minWidth: 120,
                            "&:hover": {
                                backgroundColor: isWebsiteFunctional ? "#f7f7f7" : "white",
                            },
                        }}
                    >
                        View Cart
                    </Button>
                </Grid>
            </Grid>
        </Grid>

        

    );
};

export default React.memo(FloatingCartBar);
